import Icon from '@cobliteam/ui/icons';

import Tag from '@cobliteam/ui/components/Tag';

const OngoingRouteBadge = () => {
  return <Tag icon={<Icon name='radio' />} variant='surface' size='condensed' color='primary' label='Trajeto em andamento' />;
};

export default OngoingRouteBadge;
